import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

const CartCtx = createContext(null);
const KEY = "lz_cart_v1";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    http.get("/products").then((r) => {
      if (!Array.isArray(r.data)) return;
      const live = Object.fromEntries(r.data.map((p) => [p.id, p]));
      setItems((prev) => prev.filter((i) => live[i.id]).map((i) => ({ ...i, price: live[i.id].price, image: live[i.id].image })));
    }).catch(() => {});
  }, []);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => (i.id === product.id ? { ...i, quantity: Math.min(20, i.quantity + qty) } : i));
      return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, quantity: qty }];
    });
  };
  const setQty = (id, q) =>
    setItems((prev) => (q <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, quantity: Math.min(20, q) } : i))));
  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const total = useMemo(() => items.reduce((s, i) => s + i.quantity * i.price, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, add, setQty, clear, count, total, open, setOpen }}>{children}</CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
